<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.calendarNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.calendarName" clearable placeholder="名称" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="calendarNumber" label="编码" width="140" />
      <el-table-column prop="calendarName" label="名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="工作日" min-width="160">
        <template slot-scope="{ row }">{{ weekLabel(row) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.calendarId)">修改</el-button>
          <el-button type="text" @click="openTrial(row)">试算</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.calendarId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.calendarId ? '修改工作日历' : '新增工作日历'" :visible.sync="visible" width="780px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="编码" prop="calendarNumber">
          <el-input v-model="form.calendarNumber" />
        </el-form-item>
        <el-form-item label="名称" prop="calendarName">
          <el-input v-model="form.calendarName" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="form.description" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="默认工作日">
          <el-checkbox v-model="form.mondayWorking" true-label="1" false-label="0">一</el-checkbox>
          <el-checkbox v-model="form.tuesdayWorking" true-label="1" false-label="0">二</el-checkbox>
          <el-checkbox v-model="form.wednesdayWorking" true-label="1" false-label="0">三</el-checkbox>
          <el-checkbox v-model="form.thursdayWorking" true-label="1" false-label="0">四</el-checkbox>
          <el-checkbox v-model="form.fridayWorking" true-label="1" false-label="0">五</el-checkbox>
          <el-checkbox v-model="form.saturdayWorking" true-label="1" false-label="0">六</el-checkbox>
          <el-checkbox v-model="form.sundayWorking" true-label="1" false-label="0">日</el-checkbox>
        </el-form-item>
        <el-form-item label="适用班次">
          <el-select v-model="form.shiftIds" multiple filterable clearable style="width:100%">
            <el-option
              v-for="i in shiftOptions"
              :key="i.shiftId"
              :label="(i.shiftNumber || '') + ' ' + (i.shiftName || '')"
              :value="i.shiftId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="例外日">
          <div style="width:100%">
            <el-button type="text" size="small" @click="exceptionRows.push({ exceptionDate: '', exceptionType: '0', remark: '' })">添加例外</el-button>
            <el-table :data="exceptionRows" size="mini" border style="width:100%;margin-top:4px">
              <el-table-column label="日期" width="170">
                <template slot-scope="s">
                  <el-date-picker v-model="s.row.exceptionDate" type="date" value-format="yyyy-MM-dd" placeholder="日期" style="width:100%" size="mini" />
                </template>
              </el-table-column>
              <el-table-column label="类型" width="130">
                <template slot-scope="s">
                  <el-select v-model="s.row.exceptionType" size="mini" style="width:100%">
                    <el-option label="休息" value="0" />
                    <el-option label="加班出勤" value="1" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="备注" min-width="140">
                <template slot-scope="s"><el-input v-model="s.row.remark" size="mini" /></template>
              </el-table-column>
              <el-table-column width="50" align="center">
                <template slot-scope="s"><el-button type="text" size="mini" @click="exceptionRows.splice(s.$index,1)">删</el-button></template>
              </el-table-column>
            </el-table>
          </div>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="工作日试算" :visible.sync="trialVisible" width="520px">
      <el-form label-width="90px">
        <el-form-item label="日历">{{ trial.calendarName }}</el-form-item>
        <el-form-item label="日期">
          <el-date-picker v-model="trial.date" type="date" value-format="yyyy-MM-dd" style="width:100%" />
        </el-form-item>
        <el-form-item label="结果">
          <el-tag v-if="trial.checked" :type="trial.working ? 'success' : 'info'">{{ trial.working ? '工作日' : '休息日' }}</el-tag>
          <span v-else style="color:#999">请选择日期后点试算</span>
        </el-form-item>
        <el-form-item v-if="trial.shifts && trial.shifts.length" label="班次">
          <div v-for="s in trial.shifts" :key="s.shiftId">{{ s.shiftNumber }} {{ s.shiftName }}（{{ s.startTime }}-{{ s.endTime }}）</div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="trialVisible = false">关闭</el-button>
        <el-button type="primary" @click="runTrial">试算</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listWorkCalendar, getWorkCalendar, saveWorkCalendar, updateWorkCalendar, deleteWorkCalendar, shiftsForDate
} from '../../api/workCalendar'
import { selectShift } from '../../api/shift'

function emptyForm() {
  return {
    calendarId: '',
    calendarNumber: '',
    calendarName: '',
    description: '',
    active: '1',
    mondayWorking: '1',
    tuesdayWorking: '1',
    wednesdayWorking: '1',
    thursdayWorking: '1',
    fridayWorking: '1',
    saturdayWorking: '0',
    sundayWorking: '0',
    shiftIds: []
  }
}

export default {
  name: 'MesWorkCalendarPage',
  components: { ListPagination },
  data() {
    return {
      query: { calendarNumber: '', calendarName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      shiftOptions: [],
      exceptionRows: [],
      trialVisible: false,
      trial: { calendarId: '', calendarName: '', date: '', working: false, checked: false, shifts: [] },
      rules: {
        calendarNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        calendarName: [{ required: true, message: '名称不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    weekLabel(row) {
      const map = [
        ['一', row.mondayWorking], ['二', row.tuesdayWorking], ['三', row.wednesdayWorking],
        ['四', row.thursdayWorking], ['五', row.fridayWorking], ['六', row.saturdayWorking], ['日', row.sundayWorking]
      ]
      return map.filter(i => i[1] === '1').map(i => i[0]).join('') || '-'
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listWorkCalendar({
        currentPage: this.page,
        pageSize: this.pageSize,
        calendarNumber: this.query.calendarNumber,
        calendarName: this.query.calendarName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.exceptionRows = []
      this.visible = true
      selectShift().then(res => { this.shiftOptions = res.data || [] }).catch(() => { this.shiftOptions = [] })
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getWorkCalendar(id).then(res => {
        const c = res.data || {}
        this.form = Object.assign(emptyForm(), c, { shiftIds: c.shiftIds || [] })
        this.exceptionRows = (c.exceptions || []).map(e => ({
          exceptionDate: e.exceptionDate ? String(e.exceptionDate).substring(0, 10) : '',
          exceptionType: e.exceptionType || '0',
          remark: e.remark || ''
        }))
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form, {
          exceptions: this.exceptionRows.filter(r => r.exceptionDate).map(r => ({
            exceptionDate: r.exceptionDate,
            exceptionType: r.exceptionType || '0',
            remark: r.remark
          }))
        })
        const req = payload.calendarId ? updateWorkCalendar(payload) : saveWorkCalendar(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    openTrial(row) {
      this.trial = { calendarId: row.calendarId, calendarName: row.calendarName, date: '', working: false, checked: false, shifts: [] }
      this.trialVisible = true
    },
    runTrial() {
      if (!this.trial.date) {
        this.$message.warning('请选择日期')
        return
      }
      shiftsForDate({ calendarId: this.trial.calendarId, date: this.trial.date }).then(res => {
        const body = res.data || {}
        this.trial.working = !!body.working
        this.trial.shifts = body.list || []
        this.trial.checked = true
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.calendarId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteWorkCalendar(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
